<div class="bg-primary fixed inset-0 z-[9999] flex h-screen w-screen items-center justify-center">
    <svg-icon src="/assets/images/packbo-logo-white.svg" [svgStyle]="{ width: '340px', height: '340px' }" />
</div>
